// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 425) return "static/chunks/425-2b93f7aef4ca2953.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 225 ? "e78b34b7" : chunkId) + "." + {"38":"0ab198ed17c7b250","50":"cc0f1a2982ff83aa","225":"3cbdbda481c33895","242":"60c2db50f244699a","347":"d97cb99b20363188","457":"f83f9a7e804ab404","579":"f2b8d11af8fa6469","702":"b31d70e0e0959a74","972":"97fb542c09ad4295","979":"2bdb120b8054ac1b"}[chunkId] + ".js";
};